<div class="page-container">

    <div class="metltv-background">
        <img class="login-logo" (click)="router.navigate(['/'])" src="assets/img/metltvlogo.svg">
    </div>
    <div id="forgot-pass-form-container">
        <form [formGroup]="resetPassForm" *ngIf="emailPassed && !tokenExpired">
            <h3>Reset Password</h3>
            <input type="password" placeholder="Password" formControlName="password">
            <span class="error" *ngIf="pass.hasError('required') && isSubmitted">
                Please write the new password</span>
            <span class="error" *ngIf="pass.hasError('patternInvalid')">
                   Password should not contain spaces
                </span>
            <span class="error" *ngIf="pass.hasError('maxlength')||pass.hasError('minlength')">
                   Password should be between 6-15 characters
            </span>

            <input type="password" placeholder="Reenter Password" formControlName="confirm_password">
            <span class="error" *ngIf="confirmPass.hasError('notMatch')">Passwords don't match</span>
            <span class="error" *ngIf="confirmPass.hasError('required') && isSubmitted">
                Please re-type the new password</span>
            <div class="actions">
                <button (click)="changePassword()">Submit</button>
                <mat-spinner [diameter]="15" *ngIf="loader.formProcessing"></mat-spinner>
            </div>
        </form>
        <div id="token-expired-container" *ngIf="tokenExpired">
            <img src="assets/img/undraw_calendar_dutt.svg">
            <h3>Session expired.</h3>
            <p>The link is not valid anymore.</p>
            <button (click)="resendEmail()">Resend email</button>
            <mat-spinner [diameter]="15" *ngIf="loader.formProcessing"></mat-spinner>
        </div>
    </div>
</div>
